  import { NotificationService } from './../../../../Services/notification.service';
  import { NgFor } from '@angular/common';
  import { UserSupplierService } from '../../../../Services/User/Supplier/user-supplier.service';
  import { Component, OnInit } from '@angular/core';
  import { RouterLink } from '@angular/router';
  import { HttpParams } from '@angular/common/http';
import { UsersearchService } from '../../../../Services/User/UserSearch/usersearch.service';

  interface Document {
    doc_user_img?: string;
    doc_pan_front_img?: string;
    doc_pan_back_img?: string;
    doc_aadhar_front_img?: string;
    doc_aadhar_back_img?: string;
    [key: string]: any;
  }

  interface Supplier {
    id: number;
    name: string;
    mobilenumber: string;
    gstnumber: string;
    email: string;
    doc_user_img?: string;
    documents?: Document[];
  }

  @Component({
    selector: 'app-supplier-list',
    standalone: true,
    imports: [NgFor,RouterLink],
    templateUrl: './supplier-list.component.html',
    styleUrl: './supplier-list.component.css'
  })
  export class SupplierListComponent implements OnInit {

    userSupplierList: Supplier[] = [];
    fullCustomerList: Supplier[] = [];

    constructor(private userSupplierService: UserSupplierService,
      private notificationService: NotificationService,
      private userSearchService: UsersearchService
    ) { }

    ngOnInit(): void {
      this.userSearchService.searchText$.subscribe(text => {
        this.applySearchFilter(text);
      });

      this.getUserSuppliers();
    }

    applySearchFilter(searchText: string) {
    const text = (searchText || '').trim().toLowerCase();
    if (!text) {
      this.userSupplierList = [...this.fullCustomerList];
      return;
    }

    this.userSupplierList = this.fullCustomerList.filter(c =>
      String(c.name ?? '').toLowerCase().includes(text) ||
      String(c.mobilenumber ?? '').toLowerCase().includes(text) ||
      String(c.email ?? '').toLowerCase().includes(text) ||
      String(c.gstnumber ?? '').toLowerCase().includes(text)
    );
  }

    getUserSuppliers() {
      const queryParams = new HttpParams();
      this.userSupplierService.getUserSupplier(queryParams).subscribe({
        next: (res: any) => {
          this.fullCustomerList = res.data || [];
          this.applySearchFilter(this.userSearchService.getSearchText());
        },
        error: (err: any) => {
          console.error('Error fetching user supplier list:', err);
        }
      });
    }

    onDelete(id: number) {
      this.userSupplierService.deleteUserSupplier(id).subscribe({
        next: (res: any) => {
          this.notificationService.showSuccess(
            'Stone Deleted Successfully',
            'Success'
          );
          this.getUserSuppliers();
        },error: (err: any) => {
          console.error('Error deleting user supplier:', err);
        }
      });
    }
  }
